'use client';

import type { AuctionDetailsResponse } from '../../services/generated/Api';

export const getMinimumBidAmount = (auction: AuctionDetailsResponse | null): number => {
  if (!auction) return 0;
  return auction.currentBid + auction.minBidStep;
};

export const isLastBidderCurrentUser = (
  bids: Array<{ bidder: { id: string } }>,
  currentUserId: string | null
): boolean => {
  return bids.length > 0 && currentUserId ? bids[0].bidder.id === currentUserId : false;
};
